import vmClient from 'app/services/vmClient';
import pick from 'lodash/pick';
import { Entity, IEntityType, IEntity } from '../../types/entity';
import {
  ITeacher,
  teacherAttributes,
  teacherAssociations,
} from './Teacher';


export interface ITeacherProfile extends IEntity {
  attributes: Pick<ITeacher['attributes'],
    'id' |
    'name' |
    'gender' |
    'nationality' |
    'languageProficiencies' |
    'teachingSkills' |
    'externalProfileAffiliation'
  >;
  associations: Pick<ITeacher['associations'], 'profileImage'>;
}

export type TeacherProfile = Entity<ITeacherProfile>;

// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherProfile: IEntityType<ITeacherProfile> = vmClient.defineClass({
  typeName: 'TeacherProfile',
  version: 3,
  persisted: true,

  attributes: pick(
    teacherAttributes,
    ['name', 'gender', 'nationality', 'languageProficiencies', 'teachingSkills', 'externalProfileAffiliation'],
  ),

  associations: pick(teacherAssociations, ['profileImage']),
});
